//vue components
import Vue from 'vue';

import AnimatedIcon from './components/animated-icon.vue';
import BackToTop from './components/back-to-top.vue';
import CookieConsent from './components/cookie-consent.vue'
import Posts from './components/blog-posts.vue';
import CountUp from './components/count-up.vue';
import Iframe from './components/iframe-loader.vue';
import MarketingMsg from './components/marketing-message.vue';
import MenuBtn from './components/menu-button.vue';
import Modal from './components/modal.vue';
import Projects from './components/projects.vue';
import Tabs from './components/tabs.vue';
import Tab from './components/tab.vue';
import Typed from './components/typed.vue';
import VideoBackground from './components/video-background.vue';

import $ from 'jquery';
import slick from 'slick-carousel';

import "./animations.js";



//event bus
window.Event = new class {

  constructor() {
    this.vue = new Vue();
  }

  emit(event, data = null) {
    this.vue.$emit(event, data);
  }

  listen(event, callback) {
    this.vue.$on(event, callback)
  }
};

//vue instance
var app = new Vue({

  el: '#vue',

  data: {
    modal: {
      id: null,
      open: false
    }
  },

  components: {
    'animated-icon' : AnimatedIcon,
    'blog-posts' : Posts,
    'back-to-top' : BackToTop,
    'cookie-consent' : CookieConsent,
    'count-up' : CountUp,
    'iframe-loader' : Iframe,
    'marketing-message' : MarketingMsg,
    'menu-button' : MenuBtn,
    'modal' : Modal,
    'projects': Projects,
    'tab' : Tab,
    'tabs' : Tabs,
    'typed': Typed,
    'video-background': VideoBackground
  },

  created: function(){
    Event.listen('close-modal', this.closeModal);

    window.addEventListener('load', function(){
      var loader = document.getElementById('page-loader');
      loader.classList.add('done');
      setTimeout(()=>{ loader.parentNode.removeChild(loader) }, 2000);
    });
  },


  methods: {
    requestModal(url){
      Event.emit('open-modal', url);
    },

    openModal() {
      this.modal.open = true;
      document.body.classList.add('modal-open');
    },

    closeModal() {
      this.modal.open = false;
      document.body.classList.remove('modal-open');
    },
  }
});


$(document).ready(function(){

  let headerDD = $('div.header-nav-dd');

  $('#menu-item-238').hover(function(){
    headerDD.addClass('active');
  });

  $('.header-nav li.menu-item:not(#menu-item-238)').hover(function(){
    headerDD.removeClass('active')
  });
  
  $('nav.header-nav').mouseleave(function(){
    headerDD.removeClass('active')
  });

  $('div.slider-slick').slick({
    autoplay: true,
    autoplaySpeed: 6000,
    speed: 1000,
    swipeToSlide: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 1,
    arrows: true,
    nextArrow: '<div class="mod-next"></div>',
    prevArrow: '<div class="mod-prev"></div>',
    dots: true,
    customPaging: function(slider, i) {
      return $('<span/>');
    },
    appendArrows: $('div.slider-nav'),
    appendDots: $('div.slider-nav'),
    infinite: true,
    focusOnSelect: true,
    draggable: true,
  });


  $('div.slider-slick-projects').slick({
    autoplay: false,
    autoplaySpeed: 6000,
    speed: 1000,
    //swipeToSlide: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    nextArrow: '<div class="mod-next"></div>',
    prevArrow: '<div class="mod-prev"></div>',
    dots: true,
    appendArrows: $('div.slider-nav-projects'),
    infinite: true,
    focusOnSelect: true,
    draggable: true,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]

  });

  $('.project-d').each(function(i, d){
    let view = $(d).find('.project-d-view').height()
    let y = $(d).height() - view;
    $(d).css( 'transform', 'translateY(' + y.toString() + 'px)' )
  })

  let firstHeight = $('.accordion-item').first().find('.accordion-item-body').height() + 80
  $('.accordion-item').first().height(firstHeight)
  $('.accordion-item').first().addClass('open')

  $('.accordion-item').click(function(){
    if ( $(this).hasClass('open') ) {
      $(this).removeClass('open')
      $(this).css('height', '80px')
    } else {
      $('.accordion-item.open').css('height', '80px')
      $('.accordion-item.open').removeClass('open')
      $(this).addClass('open')
      let targetHeight = $(this).find('.accordion-item-body').height() + 100
      $(this).css('height', targetHeight.toString() + 'px' )
    }
  });

  let lastScrollTop;
  let navbar = document.getElementById('site-header'); // Get The NavBar

  if (navbar) {
    window.addEventListener('scroll', function () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > lastScrollTop) {
        navbar.style.top = '-95px';
      } else {
        navbar.style.top = '0';
      }

      lastScrollTop = scrollTop;
    });
  }

});